











































































import { Component, Vue } from "vue-property-decorator";

import DashCard from "@/components/app/shared/cards/dash-card.vue";

import { menu } from "@/config/host.config";

import type { ComplexMenuSheet } from "@/@types/menu/complex-menu";
import type { ComplexMenuVariant } from "@/@types/menu/complex-menu";

@Component({ components: { DashCard } })
class ComplexMenuRecucler extends Vue {
  sheets: ComplexMenuSheet[] = [];
  loading = true;

  async mounted(): Promise<void> {
    await this.getRecuclerSheets();
  }

  async getRecuclerSheets(): Promise<void> {
    try {
      this.loading = true;
      const params = { "match[deleted][value]": true };
      const res = await this.$axios.get(menu.complex_menu, { params });
      if (res.status === 200) this.sheets = res.data;
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    } finally {
      this.loading = false;
    }
  }

  currentVariant(sheet: ComplexMenuSheet): ComplexMenuVariant | null {
    const variant = sheet.menu.find(
      (el) => el.variant === sheet.current_variant
    );
    return variant ? variant : null;
  }

  async confirmRestore(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("complex-menu.confirm.restore")),
        {
          title: String(this.$i18n.t("buttons.restore")),
        }
      );
      if (result === true) await this.restoreSheet(id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async restoreSheet(id: string): Promise<void> {
    if (!id) return;
    try {
      const res = await this.$axios.put(menu.complex_menu_restore + "/" + id);
      if (res.status === 200) {
        const i = this.sheets.findIndex((el) => el._id === id);
        if (i >= 0) this.sheets.splice(i, 1);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async confirmForceDelete(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("complex-menu.confirm.force-delete")),
        {
          title: String(this.$i18n.t("buttons.force_delete")),
          okVariant: "danger",
        }
      );
      if (result === true) await this.forceDeleteSheet(id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async forceDeleteSheet(id: string): Promise<void> {
    if (!id) return;
    try {
      const res = await this.$axios.delete(menu.complex_menu_force + "/" + id);
      if (res.status === 200) {
        const i = this.sheets.findIndex((el) => el._id === id);
        if (i >= 0) this.sheets.splice(i, 1);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }
}
export default ComplexMenuRecucler;
